import {type NonFunctionProperties} from '@colonist/types'
import {type BaseRankedUserState, RankedUserStateType} from './BaseRankedUserState.ts'
import {RankedPlacementState} from './RankedPlacementState.ts'
import {RankedMMRState} from './RankedMMRState.ts'
import {RankedLockedState} from './RankedLockedState.ts'

export class RankedUserStateController {
    static deserialize(data: NonFunctionProperties<BaseRankedUserState>): BaseRankedUserState {
        switch(data.type) {
            case RankedUserStateType.Placement: return RankedPlacementState.deserialize(data as NonFunctionProperties<RankedPlacementState>)
            case RankedUserStateType.Ranked: return RankedMMRState.deserialize(data as NonFunctionProperties<RankedMMRState>)
            case RankedUserStateType.RankedLocked: return RankedLockedState.deserialize(data as NonFunctionProperties<RankedLockedState>)
        }
    }
}
